/**
 * Initials avatar used in hero headers.
 *
 * Reuses the aqua gradient of the existing `.user-chip .avatar` but scaled
 * up with softer corners. Drop-in for future photo-based avatars by passing
 * a ``src`` override.
 */
import { clsx } from "clsx";

function initials(first?: string | null, last?: string | null): string {
  const f = (first || "").trim();
  const l = (last || "").trim();
  if (!f && !l) return "?";
  return ((f[0] || "") + (l[0] || "")).toUpperCase();
}

export function Avatar({
  firstName,
  lastName,
  src,
  size = "hero",
  className,
}: {
  firstName?: string | null;
  lastName?: string | null;
  src?: string | null;
  size?: "hero";
  className?: string;
}) {
  const label = `${firstName ?? ""} ${lastName ?? ""}`.trim() || "contact";
  const chrome = clsx(size === "hero" && "avatar-hero", className);
  if (src) {
    return (
      <img
        className={clsx(chrome, "object-cover")}
        src={src}
        alt={label}
        style={{ width: 80, height: 80, borderRadius: 16 }}
      />
    );
  }
  return (
    <span className={chrome} aria-label={label} role="img">
      {initials(firstName, lastName)}
    </span>
  );
}
